import { render, staticRenderFns } from "./EducationalGroupCards.vue?vue&type=template&id=3a30a86c&"
import script from "./EducationalGroupCards.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports